<template>
    <!--
        Модальне вікно перегляду надісланого смс
    -->

    <modal>
        <template v-slot:title>SMS #{{ form.jsonData.sms_id }}</template>
        <template v-slot:head-bottom>
            <button type="button" class="btn btn-soft-danger btn-icon btn-sm fs-16 close-btn-email"  @click="$emit('close')"><i class="ri-close-fill align-bottom"></i></button>
        </template>
        <template v-slot:body>

            <b-row>
                <!-- Номер телефону -->
                <b-col lg="6">
                    <h4 class="fs-15">{{ $t('phone_number') }}</h4>
                    <input type="number" class="form-control" id="contactNumber" v-model="this.form.jsonData.user_phone" disabled>
                </b-col>

                <!-- Відправник -->
                <b-col lg="6">
                    <h4 class="fs-15">{{ $t('Sender') }}</h4>
                    <input type="text" class="form-control" :value="mutateName(this.form.account_id)" disabled>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <!-- Дата та час -->
                <b-col lg="6">
                    <h4 class="fs-15">{{ $t('date_time') }}</h4>
                    <input type="text" class="form-control"  v-model="this.form.datetime" disabled>
                </b-col>

                <!-- IP юзера -->
                <b-col lg="6">
                    <h4 class="fs-15">IP</h4>
                    <input type="text" class="form-control" v-model="this.form.ip" disabled>
                </b-col>
            </b-row>

            <!-- Статус доставки (звіт TurboSMS, підтягується за sms_id) -->
            <div class="mt-3">
                <h4 class="fs-15">{{ $t('status') }}</h4>
                <span class="badge" :class="deliveryBadge.cls">{{ deliveryBadge.text }}</span>
            </div>

            <!-- Текст повідомлення -->
            <div class="mb-3 mt-3">
                <h4 class="fs-15">{{ $t('Message') }}</h4>
                <textarea class="form-control" v-model="this.form.jsonData.text" disabled ></textarea>
            </div>

        </template>
        <template v-slot:footer-bottom>

            <!-- Кнопка закрити вікно -->
            <button
                class="btn link-success fw-medium"
                @click="$emit('close')"
            >
                <i class="ri-close-line me-1 align-middle"></i>
                {{ $t('close') }}
            </button>

        </template>
    </modal>
</template>

<script>
import modal from '@/components/modal-small'
import { nameWorkerAcc } from '@/usabilityScripts/getNameWorker'
import { Archive } from '@/API.js';

let apiArchive = new Archive();

export default ({
    data(){
        return {
            form: {},
            // дані картки з архіву (містять статус доставки в debugSentData.delivery)
            info: null,
        }
    },
    props:['obj'],
    components: { modal },
    created(){
        this.form = this.obj
        this.getDeliveryInfo()
    },
    methods: {
        mutateName(e){
            // Беремо ім'я співробітника за його ідентифікатором
            return nameWorkerAcc(e)
        },
        getDeliveryInfo(){
            // Підтягуємо актуальний статус доставки за id відправленої SMS
            // (лог 'sendSms' містить sms_id = sent_messages.id).
            const smsId = this.form?.jsonData?.sms_id
            if (!smsId) return
            apiArchive.getArchiveSmsInfo(smsId).then(result => {
                if (result.status === 'done') {
                    this.info = result.data
                }
            })
        },
    },
    computed: {
        // Бейдж статусу доставки — той самий мапінг, що й у archive/sms.vue.
        deliveryBadge(){
            switch (this.info?.debugSentData?.delivery?.status) {
                case 'DELIVRD': return { text: this.$t('delivered'), cls: 'bg-success' }
                case 'READ':    return { text: this.$t('smsRead'), cls: 'bg-success' }
                case 'EXPIRED': return { text: this.$t('expired'), cls: 'bg-warning' }
                case 'UNDELIV': return { text: this.$t('notDelivered'), cls: 'bg-danger' }
                case 'REJECTD': return { text: this.$t('rejected'), cls: 'bg-danger' }
            }
            // DLR ще не надійшов — але SMS прийнято оператором
            if (this.info?.sent == 1) return { text: this.$t('awaitingDelivery'), cls: 'bg-info' }
            return { text: this.$t('Null'), cls: 'bg-secondary' }
        },
    },
})
</script>
